import bus from '~/bus'

export default {
  name: 'commented',
  do: async function (payload) {
    console.log('DEBUG commented: ', this, payload)
    if (
      this.file === payload.file_id ||
      (this.fileAncestors && this.fileAncestors.includes(payload.file_id)) ||
      this.fileChildren.includes(payload.file_id) ||
      (this.file === 'recent' && payload.recent)
    ) {
      bus.$emit('refreshFeedbackPanel', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/events/commented.js